import _ from 'lodash'
import { getNumberOfVisibleAxes } from './getNumberOfVisibleAxes copy'
import { mergeGridRows } from './mergeGridRows'
import { widgetIsCompatible } from './widgetIsCompatible'

export function transformWidgets(
    dashboard: any
): {
    chartsRows: any[]
    numberOfVisibleAxes: number
} {
    if (!dashboard)
        return {
            chartsRows: [],
            numberOfVisibleAxes: 6
        }

    const gridDash = dashboard?.jsonConfig?.layoutModes?.desktop?.grid as Grid[]
    const cols = dashboard?.jsonConfig?.layoutModes?.desktop?.cols as number
    const widgets = dashboard.widgets as Widget[]
    const normalizeGrid = _.sortBy(
        Object.entries(gridDash).reduce(
            (state, [id, grid]) => [
                ...state,
                {
                    ...grid,
                    id: parseInt(id)
                }
            ],
            []
        ),
        'col'
    )
    const widgetsVerticalIds = widgets
        .filter(widget => widgetIsCompatible(widget))
        .map(({ id }) => String(id)) as string[]

    const widgetsByRow = mergeGridRows(
        _.groupBy(
            normalizeGrid.filter(({ id }) => widgetsVerticalIds.includes(String(id))),
            'row'
        )
    )

    const numberOfVisibleAxes = getNumberOfVisibleAxes(widgets)

    return {
        chartsRows: Object.entries(widgetsByRow).map(([row, grids]: [string, Grid[]]) => {
            const totalColsUsed = grids.reduce((s, { size_x }) => s + size_x, 0)

            return grids.map(grid => {
                const widget = widgets.find(({ id }) => grid.id === id)
                return {
                    widget: {
                        ...widget,
                        jsonConfig: {
                            ...widget.jsonConfig
                        },
                        dashboard: {
                            ...widget.dashboard,
                            name: `[__PRINT_PDF__]` + widget.dashboard.name,
                            id: '0'
                        }
                    },

                    width: `${((grid.size_x / totalColsUsed) * 100).toFixed(2)}%`,
                    numberOfVisibleAxes
                }
            })
        }),
        numberOfVisibleAxes
    }
}

interface Grid {
    col: number
    row: number
    size_x: number
    size_y: number
    id: number
}

interface layout {
    cols: number
    margin: number
    padding: number
    titleSize: number
    grid: Grid
}
